import { Common } from "@components/common/CommonTypes";
import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import RatingStars from "@components/ui/RatingStars";
import GS from "@ts/GlobalSetting";
import { Product } from "./ProductTypes";
import ReviewPhotoList from "./ReviewPhotoList";
import Tools from "@root/ts/Tools";

export default class Review extends ComponentBase
{
  constructor(elem: ComponentElem, data: Product.ReviewData)
  {
    super(elem);

    let $reviewPhotoList = this.$root.find(`[component="review-photo-list"]`);

    if(data.photo_list.length)
    {
      ReviewPhotoList.generate(data.photo_list, $reviewPhotoList[0] as ComponentElem);
    }
    else
    {
      $reviewPhotoList.detach();
    }

    this.$root.find(".user-name").text(data.user_name);
    this.$root.find(".comment-date").text(data.comment_date);
    this.$root.find(".text").text(data.comment_text);
    

    let ratingStarsElem: ComponentElem = this.$root.find(`[component="rating-stars"]`)[0] as ComponentElem,
    ratingStars: RatingStars = new RatingStars(ratingStarsElem);
    ratingStars.setValue(Tools.parseFloat(data.rating) / GS.reviewMaxRating);
    
  }
}